import { Injectable } from '@angular/core';
import { EventService } from './event.service';
import { V3EventService } from './v3-event.service';
import Event from '../../../core/models/event';
import { BehaviorSubject, forkJoin, lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  public _events: Event[] = [];

  fetched = new BehaviorSubject<undefined>(undefined);
  loading = true;

  constructor(
    private eventService: EventService,
    private v3EventService: V3EventService
  ) {
    // Both sources are merged into one grid. Each call swallows its own
    // errors, so this always resolves — if v3 is down the listing simply
    // renders the legacy events on their own.
    lastValueFrom(
      forkJoin({
        legacy: this.eventService.getDashboardEvents(),
        v3: this.v3EventService.getEvents(),
      })
    ).then(({ legacy, v3 }) => {
      this._events = [...legacy, ...v3].sort((a, b) => {
        if (a.hasAdd !== b.hasAdd) return a.hasAdd ? -1 : 1;
        return +new Date(a.startAt) - +new Date(b.startAt);
      });
      this.fetched.next(undefined);
      this.loading = false;
    });
  }
}
